<div id="connection-overlay" class="d-flex" *ngIf="shouldShow" @fadeInOut>
  <div class="w-100 d-flex flex-column justify-content-center align-items-center p-5">

    @if (!showContinue && !showExit) {
      <div class="mb-3">
        <fa-icon class="me-1" [icon]="faTriangleExclamation"></fa-icon>
        <span>Unable to establish a connection to the Internet. Attempting to reconnect. Please ensure you are connected to a stable Internet source before continuing the assessment.</span>
      </div>

      <svg width="48" height="48" viewBox="0 0 48 48"
         fill="#cccccc"
         xmlns="http://www.w3.org/2000/svg">
      <style>
        .spinner_jCIR {
          animation: spinner_B8Vq .9s linear infinite;
          animation-delay: -.9s;
        }

        .spinner_upm8 {
          animation-delay: -.8s
        }

        .spinner_2eL5 {
          animation-delay: -.7s
        }

        .spinner_Rp9l {
          animation-delay: -.6s
        }

        .spinner_dy3W {
          animation-delay: -.5s
        }

        @keyframes spinner_B8Vq {
          0%, 66.66% {
            animation-timing-function: cubic-bezier(0.36, .61, .3, .98);
            y: 12px;
            height: 24px
          }
          33.33% {
            animation-timing-function: cubic-bezier(0.36, .61, .3, .98);
            y: 2px;
            height: 44px
          }
        }</style>
      <rect class="spinner_jCIR" x="2" y="12" width="5.6" height="24"/>
      <rect class="spinner_jCIR spinner_upm8" x="11.6" y="12" width="5.6" height="24"/>
      <rect class="spinner_jCIR spinner_2eL5" x="21.2" y="12" width="5.6" height="24"/>
      <rect class="spinner_jCIR spinner_Rp9l" x="30.8" y="12" width="5.6" height="24"/>
      <rect class="spinner_jCIR spinner_dy3W" x="40.4" y="12" width="5.6" height="24"/>
    </svg>
    }
    

    @if (showContinue) {
      <div class="mt-2">
        The connection was restored.
      </div>
      <button class="btn btn-primary mt-2" (click)="doHide()">
        <span>Continue with current question</span>
      </button>
    }

    @if (showExit) {
      <div class="mt-2">
        Unable to establish a connection to the Internet. Please check your connection and try again.
      </div>
      <!--button class="btn btn-primary mt-2" (click)="doExit()">
        <span>Exit and Continue Later</span>
      </button-->
    }

  </div>

</div>
